// import { motion } from "framer-motion";
import { memo } from "react";

import AdobeViewer from "../Pdf/AdobeViewer";

// import { IoMdClose } from "react-icons/io";

function chooseRenderMethod(type, url, fileName) {
  switch (type) {
    case "konveio":
    case "google":
    case "office":
    case "embed":
      return (
        <iframe
          width="100%"
          height="900"
          src={url}
          frameBorder="0"
          // className="hidden"
        ></iframe>
      );

    default:
      return <AdobeViewer url={url} fileName={fileName} />;
  }
}

function PDFViewer({ urlFile }) {
  return (
    <div className="h-full w-full">
      {chooseRenderMethod(
        urlFile?.fileType,
        urlFile?.fileUrl,
        urlFile?.fileName
      )}
    </div>
  );
}

export default memo(PDFViewer);
